import { useEffect } from 'react';
import { useOidc } from '@nohara-dxdev/react-oidc';
import { useNavigate } from 'react-router';

import { MemberForm } from '../components/member-form';

import { checkPermission } from '@/utils/helpers';
import { FunctionName, PermissionAction } from '@/lib/enums';

export const MembersDetailPage = () => {
  const { permissions } = useOidc();
  const navigate = useNavigate();
  useEffect(() => {
    if (!checkPermission(permissions, FunctionName.STAFF_MANAGEMENT, PermissionAction.UPDATE)) {
      navigate('/404');
      return;
    }
  }, [permissions, navigate]);
  return <MemberForm canUpdate={true} />;
};
